import React from "react";

import { useCourse } from "api/hooks";
import { routes } from "consts";
import { FaWpforms } from "react-icons/fa";
import { GoChecklist, GoPeople, GoVideo } from "react-icons/go";
import { GrDocumentUser } from "react-icons/gr";
import { MdContentCopy, MdOpenInNew } from "react-icons/md";
import { PiPlugsConnected } from "react-icons/pi";
import { Link } from "react-router-dom";
import { useToaster } from "utils";
import { clientAppUrl } from "../../../branding";

interface ManageCourseBaseInfoProps {
  courseId: number;
}

export const ManageCourseBaseInfo = ({ courseId }: ManageCourseBaseInfoProps) => {
  const { data: course } = useCourse(courseId);

  if (!course) return null;
  const registrationFormUrl = `${clientAppUrl}/kursy/${course.data.slug}/zapisz-sie`;
  return (
    <>
      <div className="mt-2 flex flex-col justify-center gap-2">
        <div className="flex flex-col items-center">
          <div className="flex w-full flex-col flex-wrap justify-evenly gap-2">
            <Tile href={routes.COURSE_PAGE.DOCUMENTS(course.data.id)} icon={<GrDocumentUser size={24} />}>
              Dokumenty
            </Tile>

            <Tile href={routes.COURSES_MANAGE_NESTED.RESOURCES(course.data.id)} icon={<GoVideo size={24} />}>
              Strefa studenta
            </Tile>

            <Tile href={routes.COURSES_MANAGE_NESTED.STUDENTS(course.data.id)} icon={<GoPeople size={24} />}>
              Kursanci
            </Tile>
            <Tile href={routes.COURSES_MANAGE_NESTED.ATTENDANCE(course.data.id)} icon={<GoChecklist size={24} />}>
              Obecność
            </Tile>
            <Tile
              href={routes.COURSES_MANAGE_NESTED.INTEGRATIONS(course.data.id)}
              icon={<PiPlugsConnected size={24} />}
            >
              Integracje
            </Tile>
            <div className="flex items-stretch gap-2">
              <Tile href={registrationFormUrl} target="_blank" icon={<FaWpforms size={24} />} className="flex-1">
                Karta zgłoszeniowa
              </Tile>
              <CopyLinkButton url={registrationFormUrl} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

interface TileProps {
  icon: React.ReactNode;
  children: string;
  href: string;
  target?: React.HTMLAttributeAnchorTarget;
  className?: string;
}
const Tile = ({ href, icon, children, target, className = "" }: TileProps) => {
  return (
    <Link
      to={href}
      target={target}
      className={`${className} flex cursor-pointer items-center gap-4 rounded-sm bg-slate-100 p-2 hover:bg-slate-200 dark:bg-slate-600 dark:text-white dark:hover:bg-slate-700`}
    >
      <div className="flex items-center justify-center">{icon}</div>
      <div className="text-xs font-semibold">{children}</div>
      {target === "_blank" && <MdOpenInNew className="ml-auto" />}
    </Link>
  );
};

// Rendered as a sibling of the tile link (not nested inside it), so copying never opens the form.
const CopyLinkButton = ({ url }: { url: string }) => {
  const { showInfo } = useToaster();
  return (
    <button
      type="button"
      title="Kopiuj link"
      aria-label="Kopiuj link do karty zgłoszeniowej"
      onClick={() => {
        navigator.clipboard.writeText(url);
        showInfo("Skopiowano link");
      }}
      className="flex items-center justify-center rounded-sm bg-slate-100 px-3 hover:bg-slate-200 dark:bg-slate-600 dark:text-white dark:hover:bg-slate-700"
    >
      <MdContentCopy size={18} />
    </button>
  );
};
